export default __webpack_public_path__ + "static/media/clinica.4314feed.png";